module.exports = __webpack_public_path__ + "static/Lessonly-a6736289c2a414f56be1e46c876afde7.png";